import React from 'react';
import { LocaleContext } from '../components/LocalizationProvider.esm.js';

const useLocalization = ()=>React.useContext(LocaleContext);

export { useLocalization as default };
